import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChartColumn,
  faCreditCard,
  faGlobe,
  faLanguage,
  faLink,
  faPalette,
  faPlug,
  faRobot,
  faShieldHalved,
  faBullseye,
  faUser,
  faBoxesStacked,
} from '@fortawesome/free-solid-svg-icons';

const Features = () => {
  const features = [
    {
      icon: <FontAwesomeIcon icon={faPlug} />,
      title: 'Embedded Contact Buttons',
      description: 'Customizable Call, SMS, and Email buttons on your app or website — customers reach you without ever leaving the page.',
      color: 'cyan'
    },
    {
      icon: <FontAwesomeIcon icon={faRobot} />,
      title: 'AI Agent (24/7)',
      description: 'Always-on intelligent response for cost reduction. Handles routine queries around the clock in 30+ languages.',
      color: 'purple'
    },
    {
      icon: <FontAwesomeIcon icon={faGlobe} />,
      title: 'Browser-Based Calling',
      description: 'Global reach via browser-based communication — no app download, no desk phone, just a browser tab.',
      color: 'emerald'
    },
    {
      icon: <FontAwesomeIcon icon={faChartColumn} />,
      title: 'Analytics & Reports',
      description: 'BI-powered insights and reports to support informed business decisions. Clear, concise data at every interaction level.',
      color: 'amber'
    },
    {
      icon: <FontAwesomeIcon icon={faLanguage} />,
      title: 'Multi-Language AI',
      description: 'AI agents engage customers in 30+ languages — removing language barriers for global commerce.',
      color: 'rose'
    },
    {
      icon: <FontAwesomeIcon icon={faLink} />,
      title: 'CRM Integration',
      description: 'APIs to connect with your CRM of choice — sync contacts, interactions, and leads automatically.',
      color: 'cyan'
    },
    {
      icon: <FontAwesomeIcon icon={faBullseye} />,
      title: 'Icon-to-Agent Mapping',
      description: 'Link contact icons to specific agents so customers are always routed to the exact right representative.',
      color: 'purple'
    },
    {
      icon: <FontAwesomeIcon icon={faUser} />,
      title: 'Customer Context',
      description: 'Key insights before every interaction — page source, time on page — enabling precise, informed conversations.',
      color: 'emerald'
    },
    {
      icon: <FontAwesomeIcon icon={faCreditCard} />,
      title: 'Pay-Per-Use Pricing',
      description: 'Flexible pricing that scales with usage. Start with 10 free calls/SMS/emails per month — upgrade only as you grow.',
      color: 'amber'
    },
    {
      icon: <FontAwesomeIcon icon={faPalette} />,
      title: 'Custom Branding',
      description: 'Fully customizable C2C icons and branding to match your company identity — from logo to color to button style.',
      color: 'rose'
    },
    {
      icon: <FontAwesomeIcon icon={faBoxesStacked} />,
      title: 'Bulk Upload',
      description: 'Pair contact icons with product information in bulk — scale your embedded communication across thousands of products.',
      color: 'cyan'
    },
    {
      icon: <FontAwesomeIcon icon={faShieldHalved} />,
      title: 'Spam Filtering',
      description: 'Only qualified, contextual conversations reach your agents — eliminating wasted time on spam and irrelevant contacts.',
      color: 'purple'
    }
  ];

  return (
    <section id="features" className="features-section">
      <div className="section-container">
        <div className="section-header reveal">
          <div className="section-label">Platform Features</div>
          <h2 className="section-title">Everything You Need to Connect Smarter</h2>
          <p className="section-description">
            12 powerful features that power real business impact.
          </p>
        </div>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className={`feature-card reveal ${feature.color}`}>
              <div className={`feature-icon ${feature.color}`}>
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
